import { getRequest, postRequest } from "../networking/client";
import { Endpoint } from "../networking/endpoints";
import { GenericResponse } from "../networking/types";

type FetchFormProps = {
  id: string;
};

type FetchFormData = {
  form: Form;
};

export type Question = {
  id: string;
  body: string;
  isRequired: boolean;
  answer: string;
  hasError: boolean;
};

export type Form = {
  id: string;
  title: string;
  logoUrl: string;
  description: string;
  questions: Question[];
};

type Response = {
  questionId: string;
  answer: string;
};

type FormSubmissionPaylod = {
  walletAddress: string;
  signature: string;
  message: string;
  hashedResponses: string;
  responses: Response[];
};

type FormSubmissionData = {
  id: String;
  payload: FormSubmissionPaylod;
};

const DUPLICATE_SUBMISSION_ERROR_CODE = 409;
export class FormService {
  fetchForm = async ({
    id,
  }: FetchFormProps): Promise<GenericResponse<FetchFormData>> => {
    try {
      const response = await getRequest(Endpoint.forms(`${id}`));

      const responseData = response.data;
      const mappedData: Form = {
        id: responseData.uuid,
        title: responseData.title,
        logoUrl: responseData.logo_url,
        //TODO: Get back end to return this
        description:
          "After you click submit, make sure you sign with your wallet that holds your HAPE(s), Genesis HAPE or your HAPE Badge(s).",
        questions: responseData.questions.map((question: any) => ({
          id: question.id,
          body: question.body,
          isRequired: true,
          answer: "",
          hasError: false,
        })),
      };
      return {
        success: true,
        data: {
          form: mappedData,
        },
      };
    } catch (error) {
      return { success: false, error: "An error occured fetching the form" };
    }
  };

  submitForm = async ({
    id,
    payload,
  }: FormSubmissionData): Promise<GenericResponse> => {
    try {
      await postRequest(Endpoint.responses(`${id}`), {
        auth: {
          wallet_address: payload.walletAddress,
          signature: payload.signature,
          message: payload.message,
        },
        hashed_responses: payload.hashedResponses,
        responses: payload.responses.map((response) => ({
          question_id: response.questionId,
          answer: response.answer,
        })),
      });

      return { success: true };
    } catch (error: any) {
      if (error?.response?.status === DUPLICATE_SUBMISSION_ERROR_CODE) {
        return {
          success: false,
          error: `A form has already been submitted with this wallet address: ${payload.walletAddress}`,
        };
      }
      return {
        success: false,
        error:
          "An error occurred trying to submit your form. Please try again.",
      };
    }
  };
}
